<template>
  <b-row>
    <b-col>
      <vue-form-generator
        :model="model"
        :schema="form.schema"
        :options="form.options"
        ref="form"
      ></vue-form-generator>
      <b-row>
        <b-col class="text-right" @click="create">
          <b-button
            id="create-payment-method-btn"
            class="btn-anchor raised"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { DEFINE_PAYMENT_METHODS } from '@/vuex/modules/payments/types/actions';

import PAYMENT_SCHEMA from '@/components/payments/create/resources/schema';


export default {
  props: {
    showAccountTypeField: {
      type: Boolean,
      default: true,
    },
    showOptionField: {
      type: Boolean,
      default: true,
    },
    paymentMethodType: {
      type: String,
      default: 'ACH',
    },
    model: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        schema: PAYMENT_SCHEMA.schema(
          this.showAccountTypeField,
          this.showOptionField,
          this.paymentMethodType,
        ),
        options: PAYMENT_SCHEMA.options,
      },
    };
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    create() {
      if (!this.validate()) { return; }

      this.$reqs.post(`/users/${this.$store.getters.user.id}/payment_methods`, this.model)
        .then((result) => {
          const paymentsMethods = result.data.payment_methods;
          this.$store.dispatch(
            DEFINE_PAYMENT_METHODS,
            { paymentMethods: paymentsMethods },
          );
          this.$emit('created', paymentsMethods[paymentsMethods.length - 1]);
          this.reset();
        })
        .catch(() => {});
    },
    reset() {
      this.$emit('reset');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payments/create/PaymentMethodCreate.vue